import { useRef } from "react";
import tabletComputer from "../../../assets/general/tablet-and-computer.png";
import { useScrollReveal } from "../../../hooks/useScrollReveal";

export function Quote2() {
  const sectionRef = useRef<HTMLElement>(null);

  useScrollReveal(sectionRef, { targets: ".tenth-section img", y: 60 });
  useScrollReveal(sectionRef, { targets: ".section-masthead__heading p", delay: 0.2 });

  return (
    <section
      ref={sectionRef}
      id="section-ten"
      className="section section-masthead text-left bg-dark-1"
      data-arts-theme-text="light"
    >
      <div className="flex-column right-menu-padding left-section-padding">
        <div className="tenth-section">
          <img src={tabletComputer} alt="360PLUS on desktop and tablet" />
          <div className="section-masthead__heading">
            <p>
              <span className="legal-highlighted">360PLUS</span> requires minimal setup time
              and is available for desktop, mobile, and tablet devices. We offer customized
              development for your companies specialized needs.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
